import { IMyRegistration } from "../model/respone/registration/IMyRegistration";

/**
 * Tìm lớp bạn trong cặp LT-TH của `target` trong danh sách đã đăng ký (chỉ xét trang_thai=1).
 *   - target là TH (id_lop_lt > 0) → bạn = LT có id_lop_tc == target.id_lop_lt.
 *   - target là LT (id_lop_lt == 0) → bạn = TH có id_lop_lt == target.id_lop_tc.
 * Trả undefined nếu lớp đơn lẻ (không thuộc cặp). Mirror backend ResolvePairPartnerIdsAsync — dùng
 * để dialog xác nhận hủy báo trước "cả cặp LT+TH sẽ được hủy".
 */
export function findPairPartner(
    target: IMyRegistration,
    myList: IMyRegistration[]
): IMyRegistration | undefined {
    const active = myList.filter(r => r.trang_thai === 1 && r.id_lop_tc !== target.id_lop_tc);
    if ((target.id_lop_lt ?? 0) > 0) {
        return active.find(r => r.id_lop_tc === target.id_lop_lt);
    }
    return active.find(r => (r.id_lop_lt ?? 0) === target.id_lop_tc);
}
